import React from 'react';
import './Footer.css';

function Footer() {
    return (
        <div className="footer">
            <div className="hangme">
                <img src={require('../img/board.png')} className="board" />
                <h1 className="hangingtext">Indrakant</h1>
            </div>
            {/* <img src={require('../img/bulb.png')} /> */}
        </div>
    )
}

export default Footer;